module.exports = __webpack_public_path__ + "img/Frame-5.2d11dc76.png";